/* eslint-disable no-undef */

const {
  SNAPENGAGE_CODES, IFRAMES
} = require('../constants/chat');

let chat;
let runOnce = false;

const addToClassList = (iFrameConfig) => {
  let iFrame = document.getElementById(iFrameConfig.iFrameId);
  if (iFrame) {
    let iFrameDoc = iFrame.contentDocument || iFrame.contentWindow.document;
    if (iFrameDoc) {
      let iFrameHead = iFrameDoc.head;
      if (iFrameHead) {
        let style = iFrameDoc.createElement('style');
        style.textContent = iFrameConfig.styleCss.class;
        iFrameHead.appendChild(style);
        let iFrameBody = iFrameDoc.body;
        if (iFrameBody) {
          iFrameBody.classList.add(iFrameConfig.styleCss.classId);
        }
      }
    }
  }

};

const chatStyle = () => {
  addToClassList(IFRAMES.CHAT)
};

const initChat = () => {
  const snapengageCode =  SNAPENGAGE_CODES.CX;

  if (!runOnce) {
    (function () {
      const se = document.createElement('script');
      se.type = 'text/javascript';
      se.async = true;
      se.src = `https://storage.googleapis.com/code.snapengage.com/js/${snapengageCode}.js`;
      let done = false;
      se.onload = se.onreadystatechange = function () {
        if (
          !done &&
          (!this.readyState ||
            this.readyState === 'loaded' ||
            this.readyState === 'complete')
        ) {
          done = true;
          chat = SnapEngage;
          chatStyle(); 
          SnapEngage.setCallback('Close', function (type, status) {
            chatStyle(); 
          });
          SnapEngage.setCallback('Open', function (status) {
            chatStyle(); 
          });
          SnapEngage.setCallback('Minimize', function(isMinimized, chatType, boxType) {
            chatStyle(); 
          });
        }
      };

      const s = document.getElementsByTagName('script')[0];
      s.parentNode.insertBefore(se, s);
    })();
    runOnce = true;
  }
};

const openChat = () => {
  chat.startLink();
};

export { initChat, openChat };
